import { FeeConcessionList } from "./FeeConcessionList";
import { FeeConcessionCreate } from "./FeeConcessionCreate";
import { FeeConcessionEdit } from "./FeeConcessionEdit";

export default {
    list: FeeConcessionList,
    create: FeeConcessionCreate,
    edit: FeeConcessionEdit
};
